import { render, staticRenderFns } from "./LiveToStreaming.vue?vue&type=template&id=4c7c1078&scoped=true"
import script from "./LiveToStreaming.vue?vue&type=script&lang=js"
export * from "./LiveToStreaming.vue?vue&type=script&lang=js"
import style0 from "./LiveToStreaming.vue?vue&type=style&index=0&id=4c7c1078&prod&lang=scss&scoped=true"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c1078",
  null
  
)

export default component.exports